import { createAction, props } from '@ngrx/store';

import type { Page } from '../enums/page.enum';

export const setReadOnlyPageState = createAction(
  '[ReadOnlyActionTypes] set read only page state',
  props<{ page: Page; isReadOnlyState: boolean }>(),
);
